export default function Title({ text }: { text: string }) {
  return <span className="text-[26px] font-bold text-[#1f1f1f]">{text}</span>;
}
